/**
 * Базовые URL для Strapi в tenant-panel.
 *
 * - API (server fetch): избегаем публичного nginx (504 на тяжёлых запросах) — в Docker обычно http://strapi:1337.
 * - Публичный origin: для префикса относительных путей медиа в браузере.
 */

export const getStrapiPublicOrigin = (): string => {
  const v = (
    process.env.NEXT_PUBLIC_STRAPI_ASSET_URL ||
    process.env.NEXT_PUBLIC_STRAPI_ORIGIN ||
    ''
  )
    .trim()
    .replace(/\/$/, '');
  if (v) return v;
  return 'https://panel.alekshrebtov1.fvds.ru';
};

/**
 * @deprecated Для API используйте buildStrapiApiUrl из `@/lib/strapiApi`.
 * Оставлено для совместимости: origin без суффикса `/api`.
 */
export const getStrapiApiOrigin = (): string => {
  if (typeof window === 'undefined') {
    const server = (process.env.STRAPI_SERVER_URL || 'http://strapi:1337').trim().replace(/\/$/, '');
    return server || getStrapiPublicOrigin();
  }
  return '';
};
